'use client';
import { useModalContext } from '../Modal.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function useModalContentProps() {
    const { bodyMounted, getBodyId, titleMounted, getTitleId, opened, trapFocus, closeOnEscape, onKeyDown, onClose } = useModalContext();
    const handleKeyDown = (event)=>{
        onKeyDown == null ? void 0 : onKeyDown(event);
        if (event.defaultPrevented) {
            return;
        }
        if (event.key === 'Escape' && closeOnEscape) {
            onClose();
        }
    };
    return {
        focusTrapActive: opened && trapFocus,
        contentProps: _extends({
            as: 'section',
            role: 'dialog',
            onKeyDown: handleKeyDown,
            tabIndex: -1,
            'aria-modal': true
        }, bodyMounted && {
            'aria-describedby': getBodyId()
        }, titleMounted && {
            'aria-labelledby': getTitleId()
        })
    };
}

export { useModalContentProps };
//# sourceMappingURL=useModalContentProps.js.map
